var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// components/ge-dropdown-selection.ts
import { css } from "@adornis/chemistry/directives/css";
import { ElementsDropdownSelection } from "@adornis/popover/x-dropdown-selection";
import { html, nothing } from "lit";
import { customElement } from "lit/decorators.js";
import { germaniumInputToken } from "./ge-input";
var GermaniumDropdownSelection = class extends ElementsDropdownSelection {
  get inputToken() {
    return germaniumInputToken(this);
  }
  _label() {
    return (this.placeholder || this.error) && this["placeholder-mode"] === "floating" ? html`
          <ge-mini
            ${css({
      userSelect: "none",
      marginLeft: this.spacing.md,
      marginBottom: !!this.showLabel ? this.spacing.xs : "0",
      opacity: !!this.showLabel ? "1" : "0",
      transform: !!this.showLabel ? "translateY(0)" : "translateY(20px)",
      transition: "opacity .12s ease, transform .12s ease, max-height .12s ease, margin .12s ease",
      maxHeight: !!this.showLabel ? "30px" : "0px",
      color: this.error ? this.colors.tone.error : "",
      pointerEvents: "none",
      textTransform: "uppercase"
    })}
            tone="subtle"
          >
            ${this.error || this.placeholder}
          </ge-mini>
        ` : nothing;
  }
};
GermaniumDropdownSelection = __decorateClass([
  customElement("ge-dropdown-selection")
], GermaniumDropdownSelection);
export {
  GermaniumDropdownSelection
};
